import { useDeepCompareEffect } from '../../../../hooks/useDeepCompareEffect';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import { setSelectedInitiativeCompletions } from '../../../../store/process-analysis-store/process-analysis-store.actions';
import { useFilterWasTouched } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { getDefaultInitiativeSelection } from '../../process-analysis.helpers';

/**
 * Hook to handle auto-selection of initiative completions when filters haven't been touched by the user
 *
 * @returns {void}
 */
const useAutoSelectFilters = (): void => {
  const data = useProcessAnalysisStore((state) => state.initiativeCompletionData);
  const initiativeCompletionsWasTouched = useFilterWasTouched('selectedInitiativeCompletions');

  useDeepCompareEffect(() => {
    if (data?.initiatives && !initiativeCompletionsWasTouched) {
      const defaultSelection = getDefaultInitiativeSelection(data.initiatives);
      setSelectedInitiativeCompletions(defaultSelection);
    }
  }, [data?.initiatives, initiativeCompletionsWasTouched]);
};

export { useAutoSelectFilters };
